import { render, staticRenderFns } from "./arinvrevision.vue?vue&type=template&id=3056589a"
import script from "./arinvrevision.vue?vue&type=script&lang=js"
export * from "./arinvrevision.vue?vue&type=script&lang=js"
import style0 from "./arinvrevision.vue?vue&type=style&index=0&id=3056589a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports